import { DocumentAPI } from '@/services/document-api.service'
import { userService } from '@/services/auth-api.service'
import { formService } from '../../services/form-api.service.js'
import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'

const claimFormInitialState = () => {
  return {
    standalonePolicy: {
      number: '',
      productId: '',
      resellerId: '',
      coverStartDate: '',
      coverEndDate: '',
      previousQuoteId: '',
      previousQuoteCoverStartDate: '',
      previousQuoteCoverEndDate: '',
      renewalQuoteId: '',
      renewalQuoteCoverStartDate: '',
      renewalQuoteCoverEndDate: '',
      underwriterId: '',
      policyholder: {
        title: '',
        firstname: '',
        lastname: '',
        mobileNumber: '',
        telephoneNumber: '',
        emailAddress: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          county: '',
          postcode: ''
        },
        dateOfBirth: ''
      },
      gadgets: [{}]
    },
    underwriter: {
      id: '',
      name: '',
      description: '',
      descriptionHtml: ''
    },
    claimForm: {
      formReference: '',
      formRef: '',
      insuranceLine: '',
      savedEmail: '',
      data: {
        claimReference: '',
        policy: {
          number: ''
        },
        claimant: {
          title: '',
          firstname: '',
          lastname: '',
          telephone: '',
          alternateTelephone: '',
          email: '',
          address: {
            line1: '',
            line2: '',
            city: '',
            county: '',
            postcode: ''
          },
          policyholder: '',
          ukResident: null,
          vatRegistered: null,
          dateOfBirth: '',
          identificationNumber: null,
          personalCircumstances: null
        },
        incident: {
          incidentTypeId: '',
          dateOfIncident: '',
          timeOfIncident: '',
          descriptionOfIncident: '',
          locationOfIncident: '',
          tripCountry: '',
          tripStartDate: '',
          tripEndDate: '',
          blacklistRequested: null,
          dateOfBlacklist: null,
          reported: null,
          dateReported: null,
          policeStationAddress: '',
          crimeReference: ''
        },
        gadgets: [],
        documents: [],
        occurredAbroad: null,
        otherClaims: null,
        otherClaimsCompanyName: null,
        otherClaimsGadgetDetails: null,
        otherClaimsOutcome: null,
        agreeFraud: '',
        agreeDataProtection: '',
        agreeDeclaration: ''
      }
    },
    emailConfirmed: null,
    telephoneConfirmed: null,
    submissionResponse: {
      claimReference: '',
      claimId: null,
      gadgetId: null,
      approved: null,
      otCode: null,
      incidentType: null
    },
    countries: [],
    selectedIncidentTypeL1: {
      id: '',
      parentId: '',
      label: ''
    },
    selectedIncidentTypeL2: {
      id: '',
      parentId: '',
      label: ''
    },
    selectedIncidentTypeL3: {
      id: '',
      parentId: '',
      label: ''
    },
    documentTypes: [],
    userExists: false,
    inProgressForms: [],

    selectedDeviceIndex: null,
    selectedGadget: {}
  }
}

export const claimformModule = {
  namespaced: true,
  state: claimFormInitialState,
  mutations: {
    initialise (state) {
      let json = localStorage.getItem('store')
      if (json) {
        Object.assign(state, JSON.parse(json))
      }
    },
    reset (state) {
      Object.assign(state, claimFormInitialState())
    },
    resetClaimForm (state) {
      const s = initialState()
      Object.assign(state.claimForm, s.claimForm)
    },
    setClaimReference (state, payload) {
      state.submissionResponse.claimReference = payload.claimReference
    },
    setSubmissionResponse (state, payload) {
      state.submissionResponse.claimReference = payload.claimReference
      state.submissionResponse.approved = payload.approved
      state.submissionResponse.otCode = payload.otCode
      state.submissionResponse.claimId = payload.claimId
      state.submissionResponse.gadgetId = payload.gadgetId
      state.submissionResponse.incidentType = payload.incidentType
    },
    setStandalonePolicy (state, payload) {
      state.standalonePolicy.number = payload.number
      state.standalonePolicy.productId = payload.productId
      state.standalonePolicy.resellerId = payload.resellerId
      state.standalonePolicy.coverStartDate = payload.coverStartDate
      state.standalonePolicy.coverEndDate = payload.coverEndDate
      state.standalonePolicy.previousQuoteId = payload.previousQuoteId
      state.standalonePolicy.previousQuoteCoverStartDate = payload.previousQuoteCoverStartDate
      state.standalonePolicy.previousQuoteCoverEndDate = payload.previousQuoteCoverEndDate
      state.standalonePolicy.renewalQuoteId = payload.renewalQuoteId
      state.standalonePolicy.renewalQuoteCoverStartDate = payload.renewalQuoteCoverStartDate
      state.standalonePolicy.renewalQuoteCoverEndDate = payload.renewalQuoteCoverEndDate
      state.standalonePolicy.underwriterId = payload.underwriterId
      state.standalonePolicy.policyholder.title = payload.policyholder.title
      state.standalonePolicy.policyholder.firstname = payload.policyholder.firstname
      state.standalonePolicy.policyholder.lastname = payload.policyholder.lastname
      state.standalonePolicy.policyholder.mobileNumber = payload.policyholder.mobileNumber
      state.standalonePolicy.policyholder.telephoneNumber = payload.policyholder.telephoneNumber
      state.standalonePolicy.policyholder.emailAddress = payload.policyholder.emailAddress
      state.standalonePolicy.policyholder.address.line1 = payload.policyholder.address.line1
      state.standalonePolicy.policyholder.address.line2 = payload.policyholder.address.line2
      state.standalonePolicy.policyholder.address.city = payload.policyholder.address.city
      state.standalonePolicy.policyholder.address.county = payload.policyholder.address.county
      state.standalonePolicy.policyholder.address.postcode = payload.policyholder.address.postcode
      state.standalonePolicy.policyholder.dateOfBirth = payload.policyholder.dateOfBirth
      state.standalonePolicy.gadgets = [...payload.gadgets]
    },
    setStandalonePolicy2 (state, payload) {
      state.standalonePolicy.number = payload.number
      state.standalonePolicy.productId = payload.productId
      state.standalonePolicy.resellerId = payload.resellerId
      state.standalonePolicy.underwriterId = payload.underwriterId
      state.standalonePolicy.policyholder.title = payload.policyholder.title
      state.standalonePolicy.policyholder.firstname = payload.policyholder.firstname
      state.standalonePolicy.policyholder.lastname = payload.policyholder.lastname
      state.standalonePolicy.policyholder.mobileNumber = payload.policyholder.mobileNumber
      state.standalonePolicy.policyholder.telephoneNumber = payload.policyholder.telephoneNumber
      state.standalonePolicy.policyholder.emailAddress = payload.policyholder.emailAddress
      state.standalonePolicy.policyholder.address.line1 = payload.policyholder.address.line1
      state.standalonePolicy.policyholder.address.line2 = payload.policyholder.address.line2
      state.standalonePolicy.policyholder.address.city = payload.policyholder.address.city
      state.standalonePolicy.policyholder.address.county = payload.policyholder.address.county
      state.standalonePolicy.policyholder.address.postcode = payload.policyholder.address.postcode
      state.standalonePolicy.policyholder.dateOfBirth = payload.policyholder.dateOfBirth
    },
    setInsuranceLine (state, payload) {
      state.claimForm.insuranceLine = payload.insuranceLine
    },
    setSavedEmail (state, payload) {
      state.claimForm.savedEmail = payload.savedEmail
    },
    setTrip (state, payload) {
      state.claimForm.data.incident.tripCountry = payload.tripCountry
      state.claimForm.data.incident.tripStartDate = payload.tripStartDate
      state.claimForm.data.incident.tripEndDate = payload.tripEndDate
    },
    setDocuments (state, payload) {
      Object.assign(state.claimForm.data.documents, payload)
    },
    setGadgets (state, payload) {
      Object.assign(state.claimForm.data.gadgets, payload.gadgets)
    },
    addGadget (state, payload) {
      state.claimForm.data.gadgets.push(payload)
    },
    updateGadget (state, payload) {
      state.claimForm.data.gadgets.splice(payload.index, 1, payload.gadget)
    },
    removeGadget (state, payload) {
      state.claimForm.data.gadgets.splice(payload.index, 1)
    },
    setPolicy (state, payload) {
      //console.log('-payload: ', payload)
      state.claimForm.data.policy.number = payload.number
      state.claimForm.data.policy.federationId = payload.federationId
      state.claimForm.data.policy.badgeNumber = payload.badgeNumber
      state.claimForm.data.policy.resellerId = payload.resellerId
    },
    setClaimant (state, payload) {
      state.claimForm.data.claimant.title = payload.title
      state.claimForm.data.claimant.firstname = payload.firstname
      state.claimForm.data.claimant.lastname = payload.lastname
      state.claimForm.data.claimant.telephone = payload.mobile ? payload.mobile : payload.telephone
      state.claimForm.data.claimant.alternateTelephone = payload.alternateTelephone != null ? payload.alternateTelephone : ''
      state.claimForm.data.claimant.email = payload.email
      state.claimForm.data.claimant.policyholder = payload.policyholder
      state.claimForm.data.claimant.ukResident = payload.ukResident
      state.claimForm.data.claimant.vatRegistered = payload.vatRegistered
      state.claimForm.data.claimant.dateOfBirth = payload.dateOfBirth
      if (payload.address) {
        state.claimForm.data.claimant.address.line1 = payload.address.line1
        state.claimForm.data.claimant.address.line2 = payload.address.line2
        state.claimForm.data.claimant.address.city = payload.address.city
        state.claimForm.data.claimant.address.county = payload.address.county
        state.claimForm.data.claimant.address.postcode = payload.address.postcode
      }
      if (payload.detailsDiffer !== null && typeof payload.detailsDiffer !== 'undefined') {
        state.claimForm.data.claimant.detailsDiffer = payload.detailsDiffer
      }
    },
    setClaimantIdentificationNumber(state,payload) {
      state.claimForm.data.claimant.identificationNumber = payload
    },
    setTelephoneConfirmed (state, payload) {
      state.telephoneConfirmed = payload
    },
    setEmailConfirmed (state, payload) {
      state.emailConfirmed = payload
    },
    setAltTelephone (state, payload) {
      state.claimForm.data.claimant.alternateTelephone = payload.alternateTelephone
    },
    setResidency (state, payload) {
      state.claimForm.data.claimant.ukResident = payload.ukResident
    },
    setTaxStatus (state, payload) {
      state.claimForm.data.claimant.vatRegistered = payload.vatRegistered
    },
    setPersonalCircumstances (state, payload) {
      state.claimForm.data.claimant.personalCircumstances = payload
    },
    setPolicyholder (state, payload) {
      state.claimForm.data.claimant.policyholder = payload.policyholder
    },
    setOccurredAbroad (state, payload) {
      state.claimForm.data.occurredAbroad = payload.occurredAbroad
    },
    setOtherClaims (state, payload) {
      state.claimForm.data.otherClaims = payload.otherClaims
    },
    setOtherClaimsGadgetDetails (state, payload) {
      if (state.claimForm.data.hasOwnProperty('otherClaimsGadgetDetails')) {
        state.claimForm.data.otherClaimsGadgetDetails = payload
      } else {
        if (payload !== null && typeof payload !== 'undefined') {
          Vue.set(state.claimForm.data, 'otherClaimsGadgetDetails', payload)
        }
      }
    },
    setOtherClaimsCompanyName (state, payload) {
      if (state.claimForm.data.hasOwnProperty('otherClaimsCompanyName')) {
        state.claimForm.data.otherClaimsCompanyName = payload
      } else {
        if (payload !== null && typeof payload !== 'undefined') {
          Vue.set(state.claimForm.data, 'otherClaimsCompanyName', payload)
        }
      }
    },
    setOtherClaimsOutcome (state, payload) {
      if (state.claimForm.data.hasOwnProperty('otherClaimsOutcome')) {
        state.claimForm.data.otherClaimsOutcome = payload
      } else {
        if (payload !== null && typeof payload !== 'undefined') {
          Vue.set(state.claimForm.data, 'otherClaimsOutcome', payload)
        }
      }
    },
    setAgreeFraud (state, payload) {
      state.claimForm.data.agreeFraud = payload.agreeFraud
    },
    setAgreeDataProtection (state, payload) {
      state.claimForm.data.agreeDataProtection = payload.agreeDataProtection
    },
    setAgreeDeclaration (state, payload) {
      state.claimForm.data.agreeDeclaration = payload.agreeDeclaration
    },
    setTripDetails (state, payload) {
      state.claimForm.data.incident.tripCountry = payload.tripCountry
      state.claimForm.data.incident.tripStartDate = payload.tripStartDate
      state.claimForm.data.incident.tripEndDate = payload.tripEndDate
    },
    setTripCountry (state, payload) {
      state.claimForm.data.incident.tripCountry = payload.tripCountry
    },
    setTripStartDate (state, payload) {
      state.claimForm.data.incident.tripStartDate = payload.tripStartDate
    },
    setTripEndDate (state, payload) {
      state.claimForm.data.incident.tripEndDate = payload.tripEndDate
    },
    setIncidentDetails (state, payload) {
      if (payload.incidentTypeId) {
        state.claimForm.data.incident.incidentTypeId = payload.incidentTypeId
      }
      state.claimForm.data.incident.dateOfIncident = payload.dateOfIncident
      state.claimForm.data.incident.timeOfIncident = payload.timeOfIncident
      state.claimForm.data.incident.descriptionOfIncident = payload.descriptionOfIncident
      state.claimForm.data.incident.locationOfIncident = payload.locationOfIncident
    },
    setIncidentTypeId (state, payload) {
      state.claimForm.data.incident.incidentTypeId = payload.incidentTypeId
    },
    setIncidentDate (state, payload) {
      state.claimForm.data.incident.dateOfIncident = payload.dateOfIncident
    },
    setIncidentTime (state, payload) {
      state.claimForm.data.incident.timeOfIncident = payload.timeOfIncident
    },
    setIncidentDescription (state, payload) {
      state.claimForm.data.incident.descriptionOfIncident = payload.descriptionOfIncident
    },
    setIncidentLocation (state, payload) {
      state.claimForm.data.incident.locationOfIncident = payload.locationOfIncident
    },
    setClaimFormReference (state, payload) {
      state.claimForm.formReference = payload.formReference
      state.claimForm.formRef = payload.formReference
    },
    setSelectedIncidentType (state, payload) {
      state.selectedIncidentType.level = payload.level
      state.selectedIncidentType.id = payload.id
      state.selectedIncidentType.label = payload.label
      state.selectedIncidentType.parentId = payload.parentId
    },
    setCountries (state, payload) {
      state.countries = payload
    },
    setSelectedIncidentTypeL1 (state, payload) {
      state.selectedIncidentTypeL1.id = payload.id
      state.selectedIncidentTypeL1.parentId = payload.parentId
      state.selectedIncidentTypeL1.label = payload.label
    },
    setSelectedIncidentTypeL2 (state, payload) {
      state.selectedIncidentTypeL2.id = payload.id
      state.selectedIncidentTypeL2.parentId = payload.parentId
      state.selectedIncidentTypeL2.label = payload.label
    },
    setSelectedIncidentTypeL3 (state, payload) {
      state.selectedIncidentTypeL3.id = payload.id
      state.selectedIncidentTypeL3.parentId = payload.parentId
      state.selectedIncidentTypeL3.label = payload.label
    },
    setDocumentTypes (state, payload) {
      state.documentTypes = payload
    },
    setUserExists (state, payload) {
      state.userExists = payload.code == 1
    },
    setInProgressForms (state, payload) {
      state.inProgressForms = payload
    },
    setInProgressForm (state, payload) {
      if (false) {
        console.log("setInProgressForm payload : ", payload)
      }
      state.claimForm = payload
      if (false) {
        console.log("setInProgressForm state.claimForm : ", state.claimForm)
      }
    },
    setSelectedGadget (state, payload) {
      state.selectedGadget = payload
    },
    setUnderwriter (state, payload) {
      state.underwriter = payload
    }
  },
  actions: {
    setClaimReference (context, payload) {
      context.commit('setClaimReference', payload)
    },
    setSubmissionResponse (context, payload) {
      context.commit('setSubmissionResponse', payload)
    },
    setInsuranceLineId (context, payload) {
      context.commit('setInsuranceLine', payload)
    },
    setSavedEmail (context, payload) {
      context.commit('setSavedEmail', payload)
    },
    setStandalonePolicy (context, payload) {
      context.commit('setStandalonePolicy', payload)
    },
    setStandalonePolicy2 (context, payload) {
      context.commit('setStandalonePolicy2', payload)
      context.commit('reseller/setResellerId', payload.resellerId, { root: true })
    },
    setPolicy (context, payload) {
      context.commit('setPolicy', payload)
    },
    setClaimant (context, payload) {
      context.commit('setClaimant', payload)
    },
    setClaimantIdentificationNumber(context, payload){
      context.commit('setClaimantIdentificationNumber',payload)
    },
    setClaimantCheckForUser (context, payload) {
      context.commit('setClaimant', payload)

      userService.checkUser(process.env.VUE_APP_RESELLER_ID, payload.email)
        .then(
          response => {
            context.commit('setUserExists', response)
          }
        )
    },
    setClaimantAndSavedEmail (context, payload) {
      context.commit('setClaimant', payload)
      context.commit('setSavedEmail', { savedEmail: payload.email })
      // check for existing user here and set state?

      userService.checkUser(process.env.VUE_APP_RESELLER_ID, payload.email)
        .then(
          response => {
            context.commit('setUserExists', response)
          },
          error => {

          }
        )
    },
    setAltTelephone (context, payload) {
      context.commit('setAltTelephone', payload)
    },
    setEmailConfirm (context, payload) {
      context.commit('setEmailConfirmed', payload)
    },
    setResidency (context, payload) {
      context.commit('setResidency', payload)
    },
    setTaxStatus (context, payload) {
      context.commit('setTaxStatus', payload)
    },
    setOccurredAbroad (context, payload) {
      context.commit('setOccurredAbroad', payload)
    },
    setTripDetails (context, payload) {
      context.commit('setTripDetails', payload)
    },
    setTripCountry (context, payload) {
      context.commit('setTripCountry', payload)
    },
    setTripStartDate (context, payload) {
      context.commit('setTripStartDate', payload)
    },
    setTripEndDate (context, payload) {
      context.commit('setTripEndDate', payload)
    },
    setSelectedIncidentType (context, payload) {
      switch (payload.level) {
        case 1:
          context.commit('setSelectedIncidentTypeL1', { ...payload })
          context.commit('setIncidentTypeId', payload)
          break
        case 2:
          context.commit('setSelectedIncidentTypeL2', { ...payload })
          context.commit('setIncidentTypeId', payload)
          break
        case 3:
          context.commit('setSelectedIncidentTypeL3', { ...payload })
          context.commit('setIncidentTypeId', payload)
          break
        default:
          context.commit('setSelectedIncidentTypeL1', { ...payload })
          context.commit('setSelectedIncidentTypeL2', { ...payload })
          context.commit('setSelectedIncidentTypeL3', { ...payload })
          context.commit('setIncidentTypeId', payload)
      }

      context.commit('setIncidentTypeId', { incidentTypeId: context.getters.selectedIncidentTypeId })
    },
    setIncidentDetails (context, payload) {
      context.commit('setIncidentDetails', {
        ...payload,
        incidentTypeId: context.getters.selectedIncidentTypeId
      })
    },
    setIncidentTypeId (context, payload) {
      context.commit('setIncidentTypeId', { incidentTypeId: context.getters.selectedIncidentTypeId })
    },
    setIncidentDate (context, payload) {
      context.commit('setIncidentDate', { payload })
    },
    setIncidentTime (context, payload) {
      context.commit('setIncidentTime', { payload })
    },
    setIncidentDescription (context, payload) {
      context.commit('setIncidentDescription', { payload })
    },
    setIncidentLocation (context, payload) {
      context.commit('setIncidentLocation', { payload })
    },
    addUpdateGadget (context, payload) {
      let index = context.getters.gadgetIndexByItemGUID(payload.itemGUID)

      if (index == -1) {
        context.commit('addGadget', payload)
      } else {
        context.commit('updateGadget', {
          index: index,
          gadget: { ...payload }
        })
      }
    },
    removeGadget (context, payload) {
      let index = context.getters.gadgetIndexByItemGUID(payload.itemGUID)
      context.commit('removeGadget', {
        index: index,
        gadget: { ...payload }
      })
    },
    setClaimFormReference (context, payload) {
      context.commit('setClaimFormReference', payload)
    },
    setDocuments (context, payload) {
      context.commit('setDocuments', [ ...payload ])
    },
    addUpdateDocument (context, payload) {

    },
    setOtherClaims (context, payload) {
      context.commit('setOtherClaims', payload)
    },
    setAgreeDataProtection (context, payload) {
      context.commit('setAgreeDataProtection', payload)
    },
    setAgreeFraud (context, payload) {
      context.commit('setAgreeFraud', payload)
    },
    setAgreeDeclaration (context, payload) {
      context.commit('setAgreeDeclaration', payload)
    },
    setCountries (context, payload) {
      context.commit('setCountries', payload)
    },
    fetchDocumentTypes (context, payload) {
      DocumentAPI
        .fetchDocumentTypes(payload || context.getters.selectedIncidentTypeL1.id)
        .then(response => {
          context.commit('setDocumentTypes', response.data.data)
        })
        .catch(err => {
          //
        })
        .finally()
    },
    fetchDocumentTypesV2 (context, payload) {
      let apiPayload = {
        incidentTypeId: context.getters.selectedIncidentTypeId,
        insuranceLineId: context.getters.insuranceLineId
      }
       
      DocumentAPI
        .fetchDocumentTypesV2(payload || apiPayload)
        .then(response => {
          context.commit('setDocumentTypes', response.data.data)
        })
        .catch(err => {
          //
        })
        .finally()
    },
    setInProgressForms (context, payload) {
      context.commit('setInProgressForms', payload)
    },
    reset (context) {
      context.commit('reset')
    },
    getInProgressFormsList ({ dispatch, commit, state }, params) {
      commit('setInProgressForms', [])
      if (state.inProgressForms.length == 0) {
        formService.getInProgress(params)
          .then(
            response => {
              commit('setInProgressForms', response.data)
            },
            error => {
            }
          )
      }
    },
    getInProgressForm ({ dispatch, commit, state }, params) {
      formService.getInProgressSingle(params)
        .then(
          response => {
            commit('setInProgressForm', response.data)

            let payload = {
              resellerId: process.env.VUE_APP_RESELLER_ID,
              policyNumber: state.claimForm.data.policy.number,
              policyholderDOB: state.claimForm.data.claimant.dateOfBirth,
              policyholderPostcode: state.claimForm.data.claimant.address.postcode
            }
            dispatch('getStandalonePolicy', payload)
          },
          error => {

          }
        )
    },
    getInProgressFormV2 ({ dispatch, commit, state }, params) {
      return new Promise ((resolve, reject) => {
        formService.getInProgressSingle(params)
        .then(
          response => {
            commit('setInProgressForm', response.data)

            let payload = {
              resellerId: process.env.VUE_APP_RESELLER_ID,
              policyNumber: state.claimForm.data.policy.number,
              policyholderDOB: state.claimForm.data.claimant.dateOfBirth,
              policyholderPostcode: state.claimForm.data.claimant.address.postcode
            }
            dispatch('getStandalonePolicy', payload)
            resolve(response)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    setInProgressForm ({ commit }, payload) {
      commit('setInProgressForm', payload)

      //console.log('setInProgressForm - payload: ', payload)
      userService.checkUser(process.env.VUE_APP_RESELLER_ID, payload.savedEmail)
        .then(
          response => {
            commit('setUserExists', response)
          }
        )
    },
    getStandalonePolicy ({ dispatch, commit, state }, params) {
      formService.getPolicyDetails(params)
        .then(
          response => {
            commit('setStandalonePolicy', response.data)
          },
          error => {

          }
        )
    },
    getHandoverDetails ({ dispatch, commit, state }, params) {
      formService.getHandoverDetails(params)
        .then(
          response => {
            commit('setStandalonePolicy', response.data.policy)

            commit('setInProgressForm', response.data.form)

            userService.checkUser(process.env.VUE_APP_RESELLER_ID, response.data.form.data.claimant.email)
              .then(
                response => {
                  commit('setUserExists', response)
                },
                error => {

                }
              )
          },
          error => {

          }
        )
    },
    getUnderwriter (context, payload) {      
      axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/underwriter/getunderwriter?id=' + payload)
        .then(response => {
          let apiRes = response.data
          context.commit('setUnderwriter', apiRes)
        })
        .catch(error => {
          this.apiMsg = {
            type: MSG_TYPE_ERROR,
            text: 'There seems to be a problem.  Please try again later.'
          }
        })
    },
    setUnderwriter (context, payload) {
      context.commit('setUnderwriter', payload)
    }
  },
  getters: {
    incidentDate: (state) => {
      return state.claimForm.data.incident.dateOfIncident
    },
    standalonePolicies: (state) => {
      var policy = {
        currentPolicyNum: state.standalonePolicy.number,
        currentPolicyStartDate: state.standalonePolicy.coverStartDate,
        currentPolicyEndDate: state.standalonePolicy.coverEndDate,
        previousPolicyNum: state.standalonePolicy.previousQuoteId,
        previousPolicyStartDate: state.standalonePolicy.previousQuoteCoverStartDate,
        previousPolicyEndDate: state.standalonePolicy.previousQuoteCoverEndDate,
        renewalPolicyNum: state.standalonePolicy.renewalQuoteId,
        renewalPolicyStartDate: state.standalonePolicy.renewalQuoteCoverStartDate,
        renewalPolicyEndDate: state.standalonePolicy.renewalQuoteCoverEndDate
      }
      return policy // state.standalonePolicy;
    },
    getCoveredGadgets: (state) => {
      var gadgets = state.standalonePolicy.gadgets.filter(f => (f.coverStatusId !== 7 && f.coverStatusId !== 4 && f.coverStatusId !== 8) && f.id) // filter out the deleted
      if (gadgets.length > 0 && state.claimForm.data.incident.dateOfIncident) { // only run once both gadgets and incident date
        var doi = moment(state.claimForm.data.incident.dateOfIncident, 'YYYY-MM-DD').format('YYYY-MM-DD')
        var dateOfIncident = moment(doi, 'YYYY-MM-DD')
        // filter the array by the incident date (deleted(7) not included so no worries)
        var filteredGadgets = gadgets.filter(
          function (each) {
            return dateOfIncident
              .isBetween(moment(each.coverStartDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                moment(each.coverEndDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), undefined, '[]')
          })
        if (filteredGadgets.length > 0) {
          return filteredGadgets // return gadgets within the incident date that are not status:Deleted
        } else {
          return gadgets
        }
      } else {
        return [] // return empty
      }
    },
    gadgetIndexByItemGUID: (state) => (itemGUID) => {
      for (var i = 0; i < state.claimForm.data.gadgets.length; i++) {
        if (state.claimForm.data.gadgets[i].itemGUID === itemGUID) {
          return i
        }
      }

      return -1
    },
    isFastTrackable: (state) => {
      // return state.claimForm.data.claimant.ukResident && !state.claimForm.data.occurredAbroad && state.incidentType.selectedIncidentTypeL1.id == 1000;
      return true
    },
    approved: (state) => {
      return state.submissionResponse.approved
    },
    claimReference: (state) => {
      return state.submissionResponse.claimReference
    },
    selectedIncidentTypeL1: (state) => {
      return state.selectedIncidentTypeL1
    },
    selectedIncidentTypeL2: (state) => {
      return state.selectedIncidentTypeL2
    },
    selectedIncidentTypeL3: (state) => {
      return state.selectedIncidentTypeL3
    },
    selectedIncidentTypeId: (state) => {
      if (state.selectedIncidentTypeL3.id !== '') {
        return state.selectedIncidentTypeL3.id
      }

      if (state.selectedIncidentTypeL2.id !== '') {
        return state.selectedIncidentTypeL2.id
      }

      if (state.selectedIncidentTypeL1.id !== '') {
        return state.selectedIncidentTypeL1.id
      }

      if (state.claimForm.data.incident.incidentTypeId !== '' && state.claimForm.data.incident.incidentTypeId !== null) {
        return state.claimForm.data.incident.incidentTypeId
      }
    },
    claimFormGadgets: (state) => {
      return state.claimForm.data.gadgets
    },
    claimFormDocuments: (state) => {
      return state.claimForm.data.documents
    },
    insuranceLineId: (state) => {
      return state.claimForm.insuranceLine
    },
    getUnderwriter: state => state.underwriter
  }
}
